module.exports = __webpack_public_path__ + "img/credit2.891531b9.png";